/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import {
  Header,
  Footer,
  Link_Box2,
  Search_Box1,
  Loading,
} from '../../../components/index'
import { WebApi } from '../../../api/web'
import { GregorianToJalali2 } from '../../../utilities/convertTime'
const Documents = () => {
  useEffect(() => {
    documentsList()
  }, [])
  const [documentList, setDocumentList] = useState(null)
  const [loading, setLoading] = useState(false)
  const [valueSearch, setValueSearch] = useState('')

  const documentsList = async () => {
    setLoading(true)
    await WebApi.documentsList()
      .then((res) => {
        setLoading(false)
        setDocumentList(res.data.data.documentList.documents)
      })
      .catch((err) => {
        setLoading(false)
      })
  }
  console.log('ccc', documentList)
  return (
    <>
      <Header title='پرونده ها' />
      {!loading && documentList ? (
        <div className='container'>
          <div className='template-pages'>
            {documentList.length > 0 ? (
              <>
                <Search_Box1
                  placeholder='نام وکیل یا پرونده را وارد کنید'
                  setState={setValueSearch}
                />
                {documentList

                  .filter((data) => {
                    return (
                      data.title
                        .toLowerCase()
                        .includes(valueSearch.toLowerCase()) ||
                      data.lawyer.fname
                        .toLowerCase()
                        .includes(valueSearch.toLowerCase()) ||
                      data.lawyer.lname
                        .toLowerCase()
                        .includes(valueSearch.toLowerCase())
                    )
                  })

                  .map(
                    (document, index) =>
                      document.lawyer && (
                        <Link_Box2
                          key={index}
                          type={2}
                          number={document.number}
                          title={document.title}
                          status={document.status}
                          name={`${document.lawyer.fname} ${document.lawyer.lname}`}
                          start={GregorianToJalali2(document.createdAt)}
                          end={GregorianToJalali2(document.finishedAt)}
                          link={`/document/${document._id}`}
                        />
                      )
                  )}
              </>
            ) : (
              <h5 className='empty-alert'>پرونده ای وجود ندارد!</h5>
            )}
          </div>
        </div>
      ) : (
        <Loading />
      )}
      <Footer />
    </>
  )
}
export default Documents
